// New caption keys; the corresponding caption entries are maintained separately in co-addin-captions.
export const CAPTION_TOOLRUNNER_EDIT_TAG_TARGET_NOT_FOUND = "cof.validation.message.edittag.targetnotfound";
export const CAPTION_TOOLRUNNER_EDIT_TAG_INVALID_OBJECTS = "cof.validation.message.edittag.invalidobjects";
export const CAPTION_TOOLRUNNER_EDIT_TAG_ZERO_OBJECTS = "cof.validation.message.edittag.zeroobjects";
export const CAPTION_TOOLRUNNER_EDIT_RULE_TARGET_NOT_FOUND = "cof.validation.message.editrule.targetnotfound";
export const CAPTION_TOOLRUNNER_EDIT_RULE_TYPE_CHANGE_FORBIDDEN = "cof.validation.message.editrule.typechangeforbidden";
export const CAPTION_TOOLRUNNER_EDIT_RULE_INVALID_TAGS = "cof.validation.message.editrule.invalidtags";
export const CAPTION_ASKAI_DISCARDED_TAG_EDIT = "cof.validation.message.askai.discardedtagedit";
export const CAPTION_ASKAI_DISCARDED_RULE_EDIT = "cof.validation.message.askai.discardedruleedit";
export const CAPTION_ASKAI_INDEX_IN_PROGRESS = "cof.validation.message.askai.indexinprogress";
export const CAPTION_ASKAI_INDEX_COMPLETED = "cof.validation.message.askai.indexcompleted";
export const CAPTION_ASKAI_DOCUMENT_SENT_ON = "cof.validation.message.askai.documentsenton";
export const CAPTION_REVIEW_MODAL_TAG_EDITS_SECTION_TITLE = "cof.validation.review.tagedits.title";
export const CAPTION_REVIEW_MODAL_RULE_EDITS_SECTION_TITLE = "cof.validation.review.ruleedits.title";
export const CAPTION_REVIEW_MODAL_OUTDATED_TAG_EDIT = "cof.validation.review.outdated.tagedit";
export const CAPTION_REVIEW_MODAL_OUTDATED_RULE_EDIT = "cof.validation.review.outdated.ruleedit";
export const CAPTION_CHAT_TIMEOUT = "cof.validation.message.failed.chattimeout";
export const CAPTION_ERROR_RULE_SIMULATION = "cof.validation.message.error.rulesimulation";
export const CAPTION_RESULT_VERIFIED = "cof.validation.result.verified";
export const CAPTION_RESULT_FAILED = "cof.validation.result.failed";
export const CAPTION_RESULT_CANNOT_EXECUTE = "cof.validation.result.cannotexecute";
export const CAPTION_RESULT_UNKNOWN_RULE = "cof.validation.result.unknownrule";
// RUNNING/QUEUED/CANCELED status labels. English defaults are resolved via
// formatMessageDefault(key, default) in RuleResultItem.getPalette until co-addin-captions ships it/en.
export const CAPTION_RESULT_STATUS_RUNNING = "cof.validation.result.status.running";
export const CAPTION_RESULT_STATUS_QUEUED = "cof.validation.result.status.queued";
export const CAPTION_RESULT_STATUS_CANCELED = "cof.validation.result.status.canceled";
// Accessible name for the streaming results progress bar. Same formatMessageDefault fallback
// pattern as the status labels above.
export const CAPTION_RESULT_PROGRESS = "cof.validation.result.progress";
export const CAPTION_ERROR_REASON_MISSING_TAG = "cof.validation.errorreason.missingtag";
export const CAPTION_ERROR_REASON_MISSING_OBJECTS = "cof.validation.errorreason.missingobjects";
export const CAPTION_ERROR_REASON_NON_NUMERIC = "cof.validation.errorreason.nonnumericvalue";
export const CAPTION_ERROR_REASON_SCRIPT_ERROR = "cof.validation.errorreason.scripterror";
export const CAPTION_ERROR_REASON_GENERIC = "cof.validation.errorreason.generic";

// Existing caption keys already available in co-addin-captions.
export const CAPTION_BUTTON_RUN_RULES = "cof.validation.button.runrules";
export const CAPTION_BUTTON_RUN_RULE = "cof.validation.button.runrule";
export const CAPTION_BUTTON_CHECK_AND_EDIT = "cof.validation.button.checkandedit";
export const CAPTION_CHAT_ERROR_GENERIC = "cof.validation.message.failed.chaterrorgeneric";
export const CAPTION_SAVED_VALIDATION_AREA = "cof.validation.message.saved.validationarea";
export const CAPTION_ERROR_VALIDATION_AREA = "cof.validation.message.error.validationarea";

export const CAPTION_LABEL_SELECT_OPTION = "cof.validation.label.selectanoption";

export const CAPTION_ADD_TAG_MODAL_PENDING_AGENT_EDIT = "cof.validation.message.addtagmodal.pendingagentedit";
export const CAPTION_ADD_RULE_MODAL_PENDING_AGENT_EDIT = "cof.validation.message.addrulemodal.pendingagentedit";

// en: "Waiting...", it: "Attendere..." (it maintained in co-addin-captions)
export const CAPTION_BASE_WAITING = "cof.base.waiting";

export const ASK_AI_STATUS_CAPTION_DEFAULTS: Record<string, { en: string; it: string }> = {
  [CAPTION_ASKAI_INDEX_IN_PROGRESS]: {
    en: "Found some new information. Updating is in progress...",
    it: "Trovate nuove informazioni. Aggiornamento in corso...",
  },
  [CAPTION_ASKAI_INDEX_COMPLETED]: {
    en: "Everything is up to date.",
    it: "Tutto è aggiornato.",
  },
  [CAPTION_ASKAI_DOCUMENT_SENT_ON]: {
    en: "Document sent on {date} - {time}",
    it: "Documento inviato il {date} - {time}",
  },
};

// Table Totals (IDS-5055)
export const CAPTION_BASE_TABLE_TOTALS = "cof.base.tabletotals";
export const CAPTION_TT_SELECT_TABLE_TO_START = "cof.validation.title.selecttabletostart";
export const CAPTION_TT_SELECT_CELLS_AND_SUBTOTAL = "cof.validation.info.selectcellsandsubtotal";
export const CAPTION_TT_CELLS_TO_SUM = "cof.validation.title.cellstosum";
export const CAPTION_TT_SUBTOTALS = "cof.validation.title.subtotals";
export const CAPTION_TT_SELECT_SUBTOTAL = "cof.validation.button.selectsubtotal";
export const CAPTION_TT_SELECT_CELL = "cof.validation.placeholder.selectcell";
export const CAPTION_TT_ROW_COLUMN_WARNING = "cof.validation.warning.rowcolumnorder";
export const CAPTION_TT_NO_TABLES = "cof.validation.info.notableyet";
export const CAPTION_TOOLRUNNER_EDIT_RULE_TABLE_TOTALS_UNSUPPORTED =
  "cof.validation.message.editrule.tabletotalsunsupported";

// Run Table Totals Rule (IDS-5906)
export const CAPTION_TT_RESULT_CORRECT = "cof.validation.result.tabletotals.correct";
export const CAPTION_TT_RESULT_INCORRECT = "cof.validation.result.tabletotals.incorrect";
export const CAPTION_TT_RESULT_STRUCTURE_CHANGED = "cof.validation.result.tabletotals.structurechanged";
export const CAPTION_TT_RESULT_NUMERIC_VALUE_EXPECTED = "cof.validation.result.tabletotals.numericvalueexpected";
export const CAPTION_TT_LINK_SHOW_DETAILS = "cof.validation.link.showdetails";
export const CAPTION_TT_TITLE_DIFFERENCES = "cof.validation.title.tabletotalsdifferences";
export const CAPTION_TT_LABEL_SUM = "cof.validation.label.sum";
export const CAPTION_TT_LABEL_SUBTOTAL = "cof.validation.label.subtotal";
export const CAPTION_TT_DIALOG_LOAD_ERROR = "cof.validation.tabletotals.dialog.loaderror";

/**
 * English default strings for the IDS-5906 table-totals captions.
 * Use via: formatMessageWithParamsDefault(CAPTION_TT_*, TABLE_TOTALS_CAPTION_DEFAULTS[CAPTION_TT_*], params)
 * T6 / T9: import these defaults so every call site uses the same fallback text.
 */
export const TABLE_TOTALS_CAPTION_DEFAULTS: Record<string, string> = {
  [CAPTION_TT_RESULT_CORRECT]: "The total is correct.",
  [CAPTION_TT_RESULT_INCORRECT]: "The total is not correct.",
  [CAPTION_TT_RESULT_STRUCTURE_CHANGED]: "The table has changed structure.",
  [CAPTION_TT_RESULT_NUMERIC_VALUE_EXPECTED]:
    "The rule cannot be run because one or more cells contain a non-numeric value where a number is expected.",
  [CAPTION_TT_LINK_SHOW_DETAILS]: "Show details",
  [CAPTION_TT_TITLE_DIFFERENCES]: "Differences for table {tableName}",
  [CAPTION_TT_LABEL_SUM]: "Sum",
  [CAPTION_TT_LABEL_SUBTOTAL]: "Subtotal",
  [CAPTION_TT_DIALOG_LOAD_ERROR]: "Unable to load details.",
};
